import {
  Navigate,
  NavLink,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import {
  Banners,
  ContentContainer,
  ContentHeader,
  ContentScroll,
  DesktopProfileDropdown,
  DesktopSidebarNavigation,
  NavItem,
  PageTitle,
} from "features/layout/components";

import MobileNavigationTabs from "common/components/MobileNavigationTabs";
import useAppStore from "common/hooks/useAppStore";
import usePageTitle from "common/hooks/usePageTitle";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useCurrentSettingsRoute from "../hooks/useCurrentSettingsRoute";
import useSettingsNavItems from "../hooks/useSettingsNavItems";
import AgencyUpgrade from "./AgencyPlan/AgencyUpgrade";

export default function WorkspaceSettings() {
  const isDesktop = useTwBreakpoint("lg");
  const { pathname } = useLocation();
  const { navItems, agencyNavItems, ltdNavItem, routes } =
    useSettingsNavItems();
  const pageTitle = usePageTitle();
  const { previousLocation } = useAppStore();
  const { bannerComponent } = useCurrentSettingsRoute();

  const routesComponent = (
    <Routes>
      {routes.map((route) => {
        const { path } = route;
        return (
          <Route
            key={path}
            path={`${path}/*`}
            element={"component" in route && route.component}
          />
        );
      })}
      <Route path="*" element={<Navigate to={routes[0].path} replace />} />
    </Routes>
  );

  if (isDesktop) {
    const isProfileActive = /\/settings\/?$/.test(pathname);

    return (
      <div className="flex gap-x-2 h-full grow">
        <DesktopSidebarNavigation
          title={pageTitle}
          navItems={navItems}
          //if the user starts on this page, there is no previous location
          backLinkProps={{ to: previousLocation || ".." }}
          footer={
            <>
              <AgencyUpgrade />
              {ltdNavItem && (
                <NavLink to={ltdNavItem.path}>
                  {({ isActive }) => (
                    <NavItem
                      isExpanded
                      isActive={isActive}
                      icon={ltdNavItem.icon}
                    >
                      {ltdNavItem.label}
                    </NavItem>
                  )}
                </NavLink>
              )}
              <div className="h-px w-full my-2 mx-auto bg-black-200" />
              <div className="[&_[data-cy=profile-button]]:w-full [&_[data-cy=profile-button]]:mx-0">
                <DesktopProfileDropdown isExpanded isActive={isProfileActive} />
              </div>
            </>
          }
        />
        <div className="flex flex-col gap-y-2 grow">
          {bannerComponent || <Banners />}
          <ContentContainer>
            <ContentScroll className="p-4 lg:pt-20 gap-y-4">
              {routesComponent}
            </ContentScroll>
          </ContentContainer>
        </div>
      </div>
    );
  }
  return (
    <ContentContainer>
      <ContentHeader>
        <PageTitle />
      </ContentHeader>
      <ContentScroll className="p-4 lg:pt-20 gap-y-4">
        <MobileNavigationTabs
          navItems={
            ltdNavItem
              ? [...navItems, ...agencyNavItems, ltdNavItem]
              : [...navItems, ...agencyNavItems]
          }
        />
        {routesComponent}
      </ContentScroll>
    </ContentContainer>
  );
}
